import { Page } from './types'
import Source from '../components/Source'

type StartComputeServerProps = { }
const render = () => <>
	<p>
            You are now ready to start the Compute Server with the command <code>grb_rs</code>.
            If you want to run this as a service, there are some built-in commands that help you
            manage the service. These commands require administrator rights.
	</p>
	<ul>
		<li><code>grb_rs install</code> installs the service. Details depend on your operating system.</li>
		<li><code>grb_rs start</code> starts the service (and installs if that was not done before).</li>
		<li><code>grb_rs stop</code> stops the service.</li>
		<li><code>grb_rs uninstall</code> uninstalls the service.</li>
	</ul>
	<Source href="https://www.gurobi.com/documentation/{version}/remoteservices/sta_a_cluster_node_as_a_pr.html"/>
</>


const StartComputeServer : Page<StartComputeServerProps> = {
	'key': 'start-compute-server',
	'title': 'Starting the Compute Server',
	render
}

export default StartComputeServer
